<template>
  <div class="content-wrapper">
    <section class="content-header">
      <h1>
        User Setup
        <small>List of user</small>
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
        <li class="active">User Setup</li>
      </ol>
    </section>

    <section class="content">
      <div class="box">
        <div class="box-header with-border">
          <h3 class="box-title">Filter User</h3>
          <div class="box-tools pull-right">
            <button type="button"
              class="btn btn-box-tool"
              data-widget="collapse">
              <i class="fa fa-minus"></i>
            </button>
          </div>
        </div>

        <div class="box-body" style="overflow: hidden;">
          <div class="row">
            <div class="col-12 col-sm-3">
              <div class="form-group">
                <label for="name">
                  Name
                </label>

                <input type="text"
                  class="form-control"
                  id="name"
                  placeholder="Search by name here"
                  v-model="params.name"
                  @keyup="onInput">
              </div>
            </div>
            <div class="col-12 col-sm-3">
              <div class="form-group">
                <label for="Email">
                  Email
                </label>

                <input type="text"
                  class="form-control"
                  id="category"
                  placeholder="Search by Email here"
                  v-model="params.email"
                  @keyup="onInput">
              </div>
            </div>
            <div class="col-12 col-sm-3">
              <div class="form-group">
                <label for="role">
                  Role
                </label>

                <select @change="onSelect" v-model="params.role" class="form-control" id="role">
                  <option :value="null">Select All</option>
                  <option  v-for="(data, index) in list.roles" :key="`${index}-${data.value}`" :value="data.value">
                  {{ data.label }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-12 col-sm-3">
              <div class="form-group">
                <label for="status">
                  Status
                </label>

                <select @change="onSelect" v-model="params.status" class="form-control" id="status">
                  <option :value="null">Select All</option>
                  <option  v-for="(data, index) in list.status" :key="`${index}-${data.value}`" :value="data.value">
                  {{ data.label }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="box">
        <div class="box-header">
          <a class="btn btn-success pull-right"
            @click.prevent="add">
            Add New User
          </a>
        </div>

        <div class="box-body">
          <table id="table" class="table table-bordered table-striped">
            <thead>
              <tr>
                <th>Full Name</th>
                <th>Email</th>
                <th>Role</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              <tr v-if="isLoading">
                <td colspan="5">
                  <strong>Loading...</strong>
                </td>
              </tr>
              <tr v-if="!isLoading && error" key="empty">
                <td colspan="5">
                  <strong>Data failed to load</strong>
                </td>
              </tr>
              <tr v-for="user in users" :key="user.id">
                <td>{{ user.name }}</td>
                <td>{{ user.email }}</td>
                <td>{{ capitalizeFirstLetter(user.role.code) }}</td>
                <td>{{ user.is_active ? 'Active' : 'Inactive' }}</td>
                <td>
                  <a class="btn btn-primary btn-xs"
                    @click.prevent="edit(user.id)">
                    Edit
                  </a>
                  <a v-if="user.is_active" 
                    class="btn btn-warning btn-xs btn-active"
                    @click.prevent="activation('deactivate', user)">
                    Deactivate
                  </a>
                  <a v-else 
                    class="btn btn-success btn-xs btn-active"
                    @click.prevent="activation('activate', user)">
                    Activate
                  </a>
                  <a class="btn btn-danger btn-xs"
                    @click.prevent="remove(user)">
                    Delete
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="box-footer">
          <Pagination
            :pagination="pagination"
            @goto-page="changePage" />
        </div>
      </div>
    </section>
  </div>
</template>
<script>

import debounce from 'lodash/debounce';
import Common from '@/mixins/Common';
import Pagination from '@/components/modules/common/Pagination';

export default {
  name: 'UserIndex',
  mixins: [Common],
  components: {
    Pagination,
  },
  data() {
    return {
      users: [],
      pagination: {},
      isLoading: false,
      error: null,

      params: {
        page: null,
        name: null,
        email: null,
        role: null,
        status: null,
      },

      list: {
        roles: [],
        status: [
          {
            label: 'Active',
            value: '1',
          },
          {
            label: 'Inactive',
            value: '0',
          },
        ],
      },
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      await this.setQuery();
      await this.fetchRoles();
      await this.fetchUsers();
    },

    setQuery() {
      return new Promise((resolve) => {
        this.params.name = this.$route.query.name || null;
        this.params.email = this.$route.query.email || null;
        this.params.role = this.$route.query.role || null;
        this.params.status = this.$route.query.status || null;
        this.params.page = this.$route.query.page || null;
        resolve();
      });
    },

    fetchRoles() {
      return new Promise(async (resolve, reject) => {
        try {
          const response = await this.axios.get('/roles?group=mister-aladin-staff');
          const { data } = response.data;
          data.forEach((role) => {
            this.list.roles.push({
              label: role.name,
              value: role.slug,
            });
          });
          resolve(data);
        } catch (error) {
          reject(error);
          this.errorModal();
        }
      });
    },

    fetchUsers(page = null) {
      return new Promise(async (resolve, reject) => {
        try {
          this.isLoading = true;
          if (page && typeof page !== 'object') this.params.page = page;

          const response = await this.axios.get('/users', { params: this.params });
          const { data, meta } = response.data;
          const isEmpty = (!data && (meta.pagination.current_page > meta.pagination.total_pages));
          this.users = (!isEmpty) ? data : [];
          this.pagination = (!isEmpty) ? meta.pagination : {};
          this.setPushState();
          resolve();
        } catch (error) {
          reject(error);
          this.errorModal();
        } finally {
          this.isLoading = false;
        }
      });
    },

    setPushState() {
      const title = `User Setup page ${this.params.page}`;
      const paramUrl = '/user-setup';
      const parameters = this.generateQuery(this.params);
      window.history.pushState(title, null, `${paramUrl}${parameters}`);
    },

    generateQuery(params) {
      if (!params) return null;

      const query = Object.keys(params)
        .filter(key => (params[key]))
        .map(key => `${key}=${this.params[key]}`);

      return (query) ? `?${query.join('&')}` : null;
    },

    onInput: debounce(function debouncedInput() {
      this.params.page = null;
      this.fetchUsers();
    }, 500),

    onSelect() {
      this.params.page = null;
      this.fetchUsers();
    },

    changePage(page) {
      this.fetchUsers(page);
    },

    errorModal(title, text) {
      this.$swal({
        title: !title ? 'Failed' : title,
        text: !text ? 'Failed to fetch data' : text,
        type: 'error',
        timer: 3000,
      });
    },

    add() {
      this.$router.push({ 
        name: 'user-form-crete',
      });
    },

    edit(id) {
      this.$router.push({
        name: 'user-form-edit',
        params: {
          id,
        },
      });
    },

    async activation(type, user) {
      const confirmation = await this.confirmModal(type, user);
      if (confirmation.value) {
        try {
          await this.axios.patch(`/users/${user.id}/${type}`);
          this.fetchUsers();
          this.successModal(type, user);
        } catch (error) {
          this.failedModal(type, user);
        }
      } else {
        this.canceledModal();
      }
    },

    async remove(user) {
      const confirmation = await this.confirmModal('delete', user);
      if (confirmation.value) {
        try {
          await this.axios.delete(`/users/${user.id}`);
          this.fetchUsers();
          this.successModal('delete', user);
        } catch (error) {
          this.failedModal('delete', user);
        }
      } else {
        this.canceledModal();
      }
    },

    confirmModal(type, user) {
      return new Promise(async (resolve) => {
        const confirmation = await this.$swal({
          title: `${this.capitalizeFirstLetter(type)}`,
          text: `Are you sure you want to ${type} ${user.name}?`,
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
        });
        resolve(confirmation);
      });
    },

    canceledModal() {
      this.$swal({
        title: 'Cancelled',
        type: 'info',
        timer: 3000,
      });
    },

    successModal(type, user) {
      this.$swal({
        title: 'Success',
        text: `${user.name} has been ${type}d`,
        type: 'success',
        timer: 3000,
      });
    },

    failedModal(type, user) {
      this.$swal({
        title: 'Failed',
        text: `Failed to ${type} ${user.name}`,
        type: 'error',
        timer: 3000,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .btn-active {
    width: 6.5rem;
  }
</style>


// WEBPACK FOOTER //
// src/components/modules/user/index.vue